// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2024/2/2
// +-------------------------------------------------------------
// |Time: 10:51
// +-------------------------------------------------------------
import {defineStore} from "pinia";
import {getAuth, getMenu, getProfile} from "@/api";

export const useUserStore = defineStore({
    id: 'user',
    state: () => {
        return {
            token: '',
            // 权限列表
            authRule: [],
            // 用户信息
            userInfo: [],
            menuList: [],
            routerAlive: true,
            keepAliveList: [],
        }
    },
    actions: {
        async loadMenus(){
            const { data, code } = await getMenu();
            if(code == 200) {
                this.menuList = data;
            }
        },
        async loadAuthRule(){
            const { data, code } = await getAuth();
            if(code == 200) {
                this.authRule = data;
            }
        },
        async updateUserInfo(){
            const { data, code } = await getProfile();
            if(code == 200) {
                this.userInfo = data;
            }
        }
    },
    persist: {
        storage: localStorage,
        paths: ['token', 'userInfo'],
    }
})
